import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面不存在 | 吃瓜日报',
    description: '你访问的页面不存在或已被移动，返回吃瓜日报首页继续浏览每日瓜料合集。',
    keywords: '吃瓜日报,404',
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-20 text-center">
        <div className="max-w-lg">
          <p className="font-heading text-7xl font-black text-primary-300">404</p>
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-900">这个瓜被小编下架了</h1>
          <p className="mt-3 text-sm leading-7 text-foreground-500">
            你访问的页面不存在或已被移动。回首页或去每日合集，还有很多新鲜瓜在等你。
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/" className="grid h-11 items-center rounded-full bg-primary-500 px-6 text-sm font-bold text-background-50 whitespace-nowrap hover:bg-primary-600">
              回到首页
            </Link>
            <Link to="/daily" className="grid h-11 items-center rounded-full border border-background-300 px-6 text-sm font-bold text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-700">
              看每日合集
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}